import Draggable from 'vuedraggable';
import Vue from 'vue';
Vue.component('draggable', Draggable);
